import { ITask } from "@/interfaces/dashboard.interface";
import TaskCard from "./task-card";
import { Plus } from "lucide-react";

interface KanbanColumnProps {
  title: string;
  tasks: ITask[];
  onAddTask: () => void;
  onEditTask: (task: ITask) => void;
  onViewTask: (task: ITask) => void;
}

export default function KanbanColumn({
  title,
  tasks,
  onAddTask,
  onEditTask,
  onViewTask,
}: KanbanColumnProps) {
  return (
    <div className="bg-[#0C1427] w-[419px] rounded-[20px] p-[30px] flex flex-col gap-[40px]">
      {/* Column Title */}
      <div className="flex gap-[612px] items-start">
        <div className="flex flex-col gap-[8px] w-[301px]">
          <p className="font-['Plus_Jakarta_Sans'] font-bold text-[24px] text-white leading-normal w-[383px]">
            {title}
          </p>
        </div>
      </div>

      {/* Task Cards */}
      <div className="flex flex-col gap-[24px] w-[359px]">
        {tasks.map((task) => (
          <TaskCard key={task.id} task={task} onEdit={onEditTask} onView={onViewTask} />
        ))}
      </div>

      {/* Add Task Button */}
      <button
        onClick={onAddTask}
        className="bg-[#7846FF] w-[259px] h-[50px] rounded-[10px] p-[10px] flex items-center justify-center gap-[3px] hover:bg-[#6635E6] transition-colors"
      >
        <Plus className="w-[24px] h-[24px] text-[#F5F2FF]" />
        <p className="font-['Plus_Jakarta_Sans'] font-bold text-[18px] text-[#F5F2FF] leading-normal whitespace-pre">
          Add nova tarefa
        </p>
      </button>
    </div>
  );
}
